(function () {
  function initFooterReinsuranceSlider(footer) {
    if (!footer) return;

    var slider = footer.querySelector('.footer__reinsurance');
    if (!slider) return;

    var swiper = null;
    var wrapper = null;
    var pagination = null;
    var mobileMq = window.matchMedia('(max-width: 1023px)');
    var initRetryTimer = null;
    var resizeTimer = null;
    var initAttempts = 0;
    var MAX_INIT_ATTEMPTS = 40;
    var INIT_RETRY_DELAY = 100;

    function hasSwiper() {
      return typeof window.Swiper !== 'undefined';
    }

    function getItems() {
      return slider.querySelectorAll('.footer__reinsurance-item');
    }

    function bindSlideClasses() {
      var items = slider.querySelectorAll('.footer__reinsurance-item');
      var i;

      for (i = 0; i < items.length; i += 1) {
        items[i].classList.add('swiper-slide');
      }
    }

    function unbindSlideClasses() {
      var items = slider.querySelectorAll('.footer__reinsurance-item');
      var i;

      for (i = 0; i < items.length; i += 1) {
        items[i].classList.remove('swiper-slide');
      }
    }

    function ensureMarkup() {
      wrapper = slider.querySelector('.footer__reinsurance-swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'footer__reinsurance-swiper-wrapper swiper-wrapper';

        var items = getItems();
        var i;
        for (i = 0; i < items.length; i += 1) {
          wrapper.appendChild(items[i]);
        }

        slider.appendChild(wrapper);
      } else {
        wrapper.classList.add('swiper-wrapper');
      }

      bindSlideClasses();

      pagination = slider.querySelector('.footer__reinsurance-swiper-pagination');
      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'footer__reinsurance-swiper-pagination swiper-pagination';
        slider.appendChild(pagination);
      } else {
        pagination.classList.add('swiper-pagination');
      }

      slider.classList.add('swiper');
    }

    function resetMarkup() {
      unbindSlideClasses();
      slider.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');

      wrapper = slider.querySelector('.footer__reinsurance-swiper-wrapper');
      if (wrapper) {
        while (wrapper.firstChild) {
          slider.insertBefore(wrapper.firstChild, wrapper);
        }
        wrapper.remove();
      }

      pagination = slider.querySelector('.footer__reinsurance-swiper-pagination');
      if (pagination) pagination.remove();
    }

    function scheduleAutoHeightUpdate() {
      if (!swiper || !mobileMq.matches) return;
      window.requestAnimationFrame(function () {
        if (swiper) swiper.updateAutoHeight();
      });
    }

    function bindImageLoadSync() {
      var images = slider.querySelectorAll('.footer__reinsurance-item img');
      var i;

      for (i = 0; i < images.length; i += 1) {
        if (!images[i].complete) {
          images[i].addEventListener('load', function () {
            scheduleAutoHeightUpdate();
          });
          images[i].addEventListener('error', function () {
            scheduleAutoHeightUpdate();
          });
        }
      }
    }

    function createOrUpdateSlider() {
      if (!hasSwiper()) return false;

      if (mobileMq.matches) {
        if (!swiper) {
          ensureMarkup();

          swiper = new window.Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            autoHeight: true,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            },
            pagination: {
              el: pagination,
              clickable: true,
              bulletClass: 'dot',
              bulletActiveClass: 'is-selected'
            }
          });

          swiper.on('init', scheduleAutoHeightUpdate);
          swiper.on('slideChangeTransitionEnd', scheduleAutoHeightUpdate);
          swiper.on('imagesReady', scheduleAutoHeightUpdate);

          bindImageLoadSync();
        } else {
          swiper.update();
        }

        scheduleAutoHeightUpdate();
        return true;
      }

      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
      resetMarkup();

      return true;
    }

    function ensureSlider() {
      if (!hasSwiper()) {
        if (initAttempts >= MAX_INIT_ATTEMPTS) return;

        initAttempts += 1;
        if (initRetryTimer) window.clearTimeout(initRetryTimer);
        initRetryTimer = window.setTimeout(ensureSlider, INIT_RETRY_DELAY);
        return;
      }

      initAttempts = 0;
      if (initRetryTimer) {
        window.clearTimeout(initRetryTimer);
        initRetryTimer = null;
      }

      createOrUpdateSlider();
    }

    function scheduleEnsureSlider() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(ensureSlider, 100);
    }

    ensureSlider();
    window.requestAnimationFrame(ensureSlider);

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', scheduleEnsureSlider);
    } else {
      mobileMq.addListener(scheduleEnsureSlider);
    }

    window.addEventListener('load', ensureSlider);
    window.addEventListener('resize', scheduleEnsureSlider);
  }

  function run() {
    initFooterReinsuranceSlider(document.querySelector('.footer[data-section-type="footer-section"]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
